var map = {
	"./content-folder.png": 58472,
	"./empty-folder.png": 87180,
	"./localisation.png": 4608,
	"./marketing.png": 99274,
	"./operations.png": 35578,
	"./other.png": 21880,
	"./product.png": 18163,
	"./stacked-books.png": 48272,
	"./tech.png": 17812
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81955;